var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',[_c('el-tab-pane',{attrs:{"label":_vm.$t('detail')}},[_c('ingress-topo',{attrs:{"data":_vm.$attrs.data}})],1),_c('el-tab-pane',{attrs:{"label":"YAML"}},[_c('yaml-container',{attrs:{"text":_vm.$attrs.data}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }